import React, { useState } from "react";
import styled from "styled-components";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Logo from '../../Assets/limitedlogo.png'
import Page from '../../Assets/page.jpg';

const Main = styled.div`
  background: #f7f9fc;
  min-height: 100vh;
`;

const Container = styled.div`
  margin: 30px;
  padding: 25px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 20px;
`;

const InputRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;

  input {
    flex: 1;
    min-width: 180px;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 14px;
  }

  input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  th, td {
    border: 1px solid #dee2e6;
    padding: 10px;
    text-align: center;
    font-size: 14px;
  }
  th {
    background: #007bff;
    color: white;
    font-weight: 500;
  }
  tbody tr:nth-child(even) {
    background-color: #f8f9fa;
  }
`;

const Button = styled.button`
  background: ${(props) => (props.variant === "secondary" ? "#6c757d" : "#007bff")};
  color: white;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.3s;

  &:hover {
    background: ${(props) => (props.variant === "secondary" ? "#5a6268" : "#0056b3")};
  }
`;

const Totals = styled.div`
  margin-top: 25px;
  p {
    font-size: 15px;
    margin: 5px 0;
  }
  b {
    color: #007bff;
  }
`;

const PreviewBox = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  margin-top: 25px;
  background: #fafafa;
`;

const AdminBusinessPanel = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [meters, setMeters] = useState([]);
  const [companyQuoted, setCompanyQUoted] = useState('')
  const [newMeter, setNewMeter] = useState({
    size: "",
    qty: "",
    unitPrice: "",
  });
  const [annualFee, setAnnualFee] = useState("");
  const [installationFee, setInstallationFee] = useState("");
  
  const [showPreview, setShowPreview] = useState(false);
  const VAT_RATE = 0.16;
const options = [
  "DN15",
  "DN20",
  "DN25",
  "DN32",
  "DN40",
  "DN50",
  "DN65",
  "DN80",
  "DN100",
  "DN150",
  "DN200",
  "DN300",
];

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewMeter((prev) => ({ ...prev, [name]: value }));
  };

  const addMeter = () => {
    const { description, size, qty, unitPrice } = newMeter;


    const total = parseFloat(qty) * parseFloat(unitPrice);
    setMeters([...meters, { description, size, qty, unitPrice, total }]);
    setNewMeter({ description: "", size: "", qty: "", unitPrice: "" });
  };

  const calculateTotal = () => {
    const subtotal = meters.reduce((acc, m) => acc + parseFloat(m.total), 0);
    const grandTotal = subtotal + parseFloat(annualFee || 0) + parseFloat(installationFee || 0);
    const vat = grandTotal * VAT_RATE;
    return { subtotal, grandTotal, vat, totalWithVAT: grandTotal + vat };
  };

  const { subtotal, grandTotal, vat, totalWithVAT } = calculateTotal();


  const formatNumber = (num) => {
  if (!num || isNaN(num)) return "0.00";
  return parseFloat(num).toLocaleString("en-KE", { minimumFractionDigits: 2 });
};



const generatePDF = () => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const subtitle = "Official Quotation / Proforma Invoice";
  const logo = Logo;

  // --- Company Info ---
  const address = `
Aqua Tools and General Hardware,
Gold Stone Plaza, Kombo Munyiri Rd,
P.O. Box 52369 – 00200,
+254 714 814 275,
info@aquatools.io
  `;

  const description = `-NB-IoT
-Type – Ultrasonic. 
-Body Material – Ductile Iron. 
-Power – 3.0v – 3.6v DC. 
-R (Q3/Q1) 250.
-Protection class – IP68.
-Temperature – Cold T50.
-Pressure/Flow rate Sensors.
-Battery Life – 6yrs`;


const  Note = `
 Note 
*There shall be a monthly reporting fee of 200 KES for each meter  that is  billed annually. 
**Looking forward for your partnership
`

const PaymentDetails = `
Payment Details:

Family Bank 
Paybill:  222111 
Account:  003000047349
`
  const img = new Image();
  img.src = Page;
  img.onload = () => {
    doc.addImage(img, "JPEG", 0, 0, 210, 297);

    // --- Header ---
    doc.addImage(logo, "PNG", 65, 10, 100, 25);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.text(subtitle, 105, 40, { align: "center" });

    doc.setFont("helvetica", "bold"); 
    doc.setFontSize(10);
    doc.text(address, 10, 50, { align: "left" });
    doc.setFont("helvetica", "normal");


   // --- Date and Validity ---
const today = new Date();
const quotedate = today.toLocaleDateString("en-GB"); // e.g. 06/11/2025

// Add 14 days for validity
const validityDate = new Date(today);
validityDate.setDate(validityDate.getDate() + 14);
const validity = `Quote Valid Until: ${validityDate.toLocaleDateString("en-GB")}`;

// Display dates on top right
doc.setFontSize(10);
doc.text(`Quote Date: ${quotedate}`, 160, 70, { align: "right" });
doc.text(validity, 160, 75, { align: "right" });


doc.setFont("helvetica", "bold"); // Set font to bold
doc.text(Note, 10, 190, { align: "left" });
doc.setFont("helvetica", "normal"); // (optional) reset back to normal after


// 🔹 Title: Bold and slightly larger
doc.setFont("helvetica", "bold");
doc.setFontSize(11);
doc.text("Payment Details:", 10, 220);

// 🔹 Details: Normal font, smaller size, aligned left
doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text([
  "Family Bank",
  "Paybill: 222111",
  "Account: 003000047349"
], 10, 226);  // small Y offset for spacing after title

    if (companyQuoted) {
      doc.setFont("helvetica", "bold"); 
      doc.setFontSize(10);
      doc.text(`Bill To: ${companyQuoted}`, 10, 80);
      doc.setFont("helvetica", "normal");
    }

    // --- Table Definition ---
    const columns = [
      { header: "Item", dataKey: "item" },
      { header: "Features", dataKey: "features" },
      { header: "Quantity", dataKey: "qty" },
      { header: "Unit Price (KES)", dataKey: "unitPrice" },
      { header: "Total (KES)", dataKey: "total" },
    ];

      const tableBody = [];

    if (meters.length > 0) {
      // Add first row with rowspan
      tableBody.push({
        item: meters[0].size,
        features: { content: description, rowSpan: meters.length, styles: { valign: "middle" } },
        qty: formatNumber(meters[0].qty),
        unitPrice: formatNumber(meters[0].unitPrice),
        total: formatNumber(meters[0].total),
      });

      // Remaining rows (features must be null)
      for (let i = 1; i < meters.length; i++) {
        tableBody.push({
          item: meters[i].size,
          features: null,
          qty: formatNumber(meters[i].qty),
          unitPrice: formatNumber(meters[i].unitPrice),
          total: formatNumber(meters[i].total),
        });
      }
    }


     // --- Summary rows ---
  // --- Summary rows ---
tableBody.push(
  { item: "Annual Reporting Fee", features: "", qty: "", unitPrice: "", total: formatNumber(annualFee) },
  { item: "Installation & Configuration", features: "", qty: "", unitPrice: "", total: formatNumber(installationFee) },
  { item: "", features: "", qty: "", unitPrice: "", total: formatNumber(subtotal) },
  { item: "VAT (16%)", features: "", qty: "", unitPrice: "Subtotal", total: formatNumber(vat) },
  { item: "", features: "", qty: "", unitPrice: "Grand Total", total: formatNumber(totalWithVAT) },
);

    // --- Draw Table ---
  doc.autoTable({
  columns,
  body: tableBody,
  startY: 90,
  theme: "grid",
  styles: { 
    fontSize: 9, 
    fontStyle: "bold",
    cellPadding: 2,
  
    valign: "middle", 
  },
  headStyles: { 
    fillColor: [0, 102, 204], 
    textColor: [255, 255, 255],
    halign: "center",     // ✅ center table headers
  },
  bodyStyles: { valign: "middle" },
  columnStyles: {
    item: {  cellWidth: 35 },
    features: {  cellWidth: 70 },
    qty: { halign: "center", cellWidth: 20 },
    unitPrice: { halign: "center", cellWidth: 35 },
    total: { halign: "center", cellWidth: 35 },
  },
  margin: { left: 10, right: 10 },

   alternateRowStyles: {
    fillColor: [240, 240, 240], // light gray background
  },
});

doc.save(`${companyQuoted}.pdf`);

  };
};


  return (
    <Main>
      <Navbar showMenuButton toggleSidebar={toggleSidebar} />
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <Container>
        <SectionTitle>Create Quotation / Proforma Invoice</SectionTitle>

        {/* Input fields */}
        <InputRow>
         <input
            name="Name of Company"
            type="text"
            placeholder="companyQuoted"
            value={newMeter.companyQuoted}
            onChange={(e) => setCompanyQUoted(e.target.value)}
          />
        
         <select
  name="size"
  value={newMeter.size}
  onChange={(e) => {
    const selectedSize = e.target.value;

  
    setNewMeter((prev) => ({
      ...prev,
      size: selectedSize,
      
    }));
  }}
  style={{
    flex: 1,
    minWidth: "180px",
    padding: "8px 10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "14px",
  }}
>
  <option value="">Select Meter Size</option>
  {options.map((opt) => (
    <option key={opt} value={opt}>
      {opt}
    </option>
  ))}
</select>

          <input
            name="qty"
            type="number"
            placeholder="Quantity"
            value={newMeter.qty}
            onChange={handleInputChange}
          />
          <input
            name="unitPrice"
            type="number"
            placeholder="Unit Price"
            value={newMeter.unitPrice}
            onChange={handleInputChange}
          />
          <Button onClick={addMeter}>Add Meter</Button>
        </InputRow>

        {/* Meter Table */}
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Description</th>
                <th>Meter Size</th>
                <th>Quantity</th>
                <th>Unit Price (KES)</th>
                <th>Total (KES)</th>
              </tr>
            </thead>
            <tbody>
              {meters.map((m, i) => (
                <tr key={i}>
                  <td>{m.description}</td>
                  <td>{m.size}</td>
                  <td>{m.qty}</td>
                  <td>{m.unitPrice}</td>
                  <td>{m.total}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        {/* Fees */}
        <InputRow style={{ marginTop: "20px" }}>
          <input
            type="number"
            placeholder="Annual Reporting Fee (KES)"
            value={annualFee}
            onChange={(e) => setAnnualFee(e.target.value)}
          />
          <input
            type="number"
            placeholder="Installation Fee (KES)"
            value={installationFee}
            onChange={(e) => setInstallationFee(e.target.value)}
          />
        </InputRow>

        {/* Totals */}
        <Totals>
          <p>Subtotal: KES {subtotal.toFixed(2)}</p>
          <p>VAT (16%): KES {vat.toFixed(2)}</p>
          <p>
            <b>Grand Total: KES {totalWithVAT.toFixed(2)}</b>
          </p>
        </Totals>

        {/* Buttons */}
        <div style={{ marginTop: "25px" }}>
          <Button onClick={() => setShowPreview(true)}>Preview</Button>
          <Button onClick={generatePDF}>Download PDF</Button>
        </div>

        {/* Preview Section */}
        {showPreview && (
          <PreviewBox>
            <h3>Quotation Preview</h3>
            <p><strong>Company:</strong> Thunder Technologies</p>
            <ul>
              {meters.map((m, i) => (
                <li key={i}>
                  {`${m.qty} × ${m.description} (${m.size}) @ KES ${m.unitPrice} = KES ${m.total}`}
                </li>
              ))}
            </ul>
            <p><strong>Total (Incl. VAT):</strong> KES {totalWithVAT.toFixed(2)}</p>
            <Button variant="secondary" onClick={() => setShowPreview(false)}>Close Preview</Button>
          </PreviewBox>
        )}
      </Container>
      <Footer />
    </Main>
  );
};

export default AdminBusinessPanel;
